import FontFaceObserver from "fontfaceobserver"

/**
 * On most browsers, there's a flash of unstyled text before the fonts
 * are loaded. Because we load a large number of font variations, this
 * time lag can be significant. Instead of waiting for fonts to load,
 * we instead make all text transparent until the fonts are loaded.
 * Note that because we may load either the variable font or the
 * non-variable font, we wait for either to load (5s timeout). If the
 * fonts fail to load, we still apply the `fonts-loaded` class.
 */
export default defineNuxtPlugin(() => {
  const interVar = new FontFaceObserver("InterVariable").load(null, 5000)
  const interNormal = new FontFaceObserver("Inter").load(null, 5000)

  Promise.race([interVar, interNormal]).then(() => {
    console.debug("Fonts loaded")
  }).catch(() => {
    console.warn("Fonts failed to load within 5 seconds")
  }).finally(() => {
    // Ensure that the fonts-loaded class is applied even if the fonts fail to load
    document.body.classList.add("fonts-loaded")
  })
})
